/**
 * Utility functions for detecting device type and operating system
 */

export const getDeviceType = () => {
  const userAgent = navigator.userAgent.toLowerCase()

  // Check for mobile devices
  const mobileRegex =
    /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i
  if (mobileRegex.test(userAgent)) {
    // Further distinguish between tablet and mobile
    const tabletRegex = /ipad|android(?!.*mobile)|tablet/i
    if (tabletRegex.test(userAgent)) {
      return 'tablet'
    }

    return 'mobile'
  }

  return 'desktop'
}

export const getOperatingSystem = () => {
  const userAgent = navigator.userAgent.toLowerCase()

  if (userAgent.includes('windows')) {
    return 'Windows'
  }
  if (userAgent.includes('mac')) {
    return 'macOS'
  }
  if (userAgent.includes('linux')) {
    return 'Linux'
  }
  if (userAgent.includes('android')) {
    return 'Android'
  }
  if (
    userAgent.includes('iphone') ||
    userAgent.includes('ipad') ||
    userAgent.includes('ipod')
  ) {
    return 'iOS'
  }
  if (userAgent.includes('cros')) {
    return 'Chrome OS'
  }

  return 'Unknown'
}

export const getBrowserInfo = () => {
  const userAgent = navigator.userAgent.toLowerCase()

  if (userAgent.includes('chrome') && !userAgent.includes('edg')) {
    return 'Chrome'
  }
  if (userAgent.includes('firefox')) {
    return 'Firefox'
  }
  if (userAgent.includes('safari') && !userAgent.includes('chrome')) {
    return 'Safari'
  }
  if (userAgent.includes('edg')) {
    return 'Edge'
  }
  if (userAgent.includes('opera') || userAgent.includes('opr')) {
    return 'Opera'
  }

  return 'Unknown'
}

export const getDeviceAndOSInfo = () => {
  return {
    deviceType: getDeviceType(),
    $os: getOperatingSystem(),
    $browser: getBrowserInfo(),
    userAgent: navigator.userAgent,
    viewportSize: `${window.innerWidth}x${window.innerHeight}`,
  }
}
